import React from "react";
import { useNavigate } from "react-router-dom";

export default function Troubleshooting({ isEN }) {
  const navigate = useNavigate();

  return (
    <div>
      <div className="flex items-center mb-8">
        {/* <div className="w-10 h-10 bg-orange-500 rounded-xl flex items-center justify-center mr-4 shadow-lg">
                    <svg
                        className="w-6 h-6 text-white"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                    </svg>
                </div> */}
        <div>
          <h2 className="text-3xl font-bold text-gray-800 dark:text-white">
            {isEN ? "Troubleshooting" : "故障排除"}
          </h2>
          <p className="text-gray-500 dark:text-gray-400 mt-1">
            {isEN
              ? "Troubleshooting guide for PIMS system"
              : "PIMS系統故障排除指南"}
          </p>
        </div>
      </div>
      <div className="space-y-6">
        <div className="bg-slate-200 dark:bg-gray-900/40 rounded-lg p-6 border border-gray-600 shadow-lg">
          <div className="flex items-center mb-4">
            <div className="w-8 h-8 bg-orange-500 rounded-lg flex items-center justify-center mr-3 shadow-md">
              <svg
                className="w-5 h-5 text-white"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>
            <h3 className="text-2xl font-bold text-gray-800 dark:text-white">
              {isEN ? "Common Issues & Solutions" : "常見問題和解決方案"}
            </h3>
          </div>

          <div className="space-y-6">
            <div className="bg-white dark:bg-gray-800 rounded-lg p-6 border border-gray-300 dark:border-gray-700 shadow-sm">
              <div className="flex items-center mb-4">
                {/* <div className="w-6 h-6 bg-red-500 rounded-lg flex items-center justify-center mr-3 shadow-sm">
                                    <svg
                                        className="w-4 h-4 text-white"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                        />
                                    </svg>
                                </div> */}
                <h4 className="text-gray-800 dark:text-white text-xl font-semibold">
                  {isEN ? "Login Issues" : "登錄問題"}
                </h4>
              </div>
              <div className="space-y-4">
                <div className="bg-white dark:bg-gray-800 rounded-lg p-4">
                  <h5 className="text-red-700 dark:text-red-400 text-sm font-semibold mb-3">
                    {isEN
                      ? "Problem: Can't log in with correct credentials"
                      : "問題：使用正確憑據無法登錄"}
                  </h5>
                  <div className="text-gray-700 dark:text-gray-300 text-sm space-y-2">
                    <p className="font-medium text-gray-800 dark:text-white">
                      {isEN ? "Solutions:" : "解決方案:"}
                    </p>
                    <ul className="ml-4 space-y-1">
                      <li className="flex items-center">
                        <div className="w-2 h-2 bg-red-500 rounded-full mr-2"></div>
                        {isEN
                          ? "Clear browser cache and cookies"
                          : "清除瀏覽器緩存和cookie"}
                      </li>
                      <li className="flex items-center">
                        <div className="w-2 h-2 bg-red-500 rounded-full mr-2"></div>
                        {isEN
                          ? "Try using an incognito/private browser window"
                          : "嘗試使用無痕/私密瀏覽器窗口"}
                      </li>
                      <li className="flex items-center">
                        <div className="w-2 h-2 bg-red-500 rounded-full mr-2"></div>
                        {isEN
                          ? "Check if Caps Lock is enabled"
                          : "檢查是否啟用了Caps Lock"}
                      </li>
                      <li className="flex items-center">
                        <div className="w-2 h-2 bg-red-500 rounded-full mr-2"></div>
                        {isEN
                          ? "Reset your password using the 'Forgot Password' link"
                          : '使用"忘記密碼"鏈接重置密碼'}
                      </li>
                      <li className="flex items-center">
                        <div className="w-2 h-2 bg-red-500 rounded-full mr-2"></div>
                        {isEN
                          ? "Contact support if the issue persists"
                          : "如果問題持續存在，請聯繫支持"}
                      </li>
                    </ul>
                  </div>
                </div>
                <hr className="border-gray-300 dark:border-gray-700" />
                <div className="bg-white dark:bg-gray-800 rounded-lg p-4">
                  <h5 className="text-red-700 dark:text-red-400 text-sm font-semibold mb-3">
                    {isEN
                      ? "Problem: Account locked after multiple failed attempts"
                      : "問題：多次嘗試失敗後賬戶被鎖定"}
                  </h5>
                  <div className="text-gray-700 dark:text-gray-300 text-sm space-y-2">
                    <p className="font-medium text-gray-800 dark:text-white">
                      {isEN ? "Solutions:" : "解決方案:"}
                    </p>
                    <ul className="ml-4 space-y-1">
                      <li className="flex items-center">
                        <div className="w-2 h-2 bg-red-500 rounded-full mr-2"></div>
                        {isEN
                          ? "Wait 15-30 minutes before trying again"
                          : "等待15-30分鐘後重試"}
                      </li>
                      <li className="flex items-center">
                        <div className="w-2 h-2 bg-red-500 rounded-full mr-2"></div>
                        {isEN
                          ? "Use the password reset function"
                          : "使用密碼重置功能"}
                      </li>
                      <li className="flex items-center">
                        <div className="w-2 h-2 bg-red-500 rounded-full mr-2"></div>
                        {isEN
                          ? "Contact an administrator for immediate unlock"
                          : "聯繫管理員立即解鎖"}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white dark:bg-gray-800 rounded-lg p-6 border border-gray-300 dark:border-gray-700 shadow-sm">
              <div className="flex items-center mb-4">
                {/* <div className="w-6 h-6 bg-yellow-500 rounded-lg flex items-center justify-center mr-3 shadow-sm">
                                    <svg
                                        className="w-4 h-4 text-white"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
                                        />
                                    </svg>
                                </div> */}
                <h4 className="text-gray-800 dark:text-white text-xl font-semibold">
                  {isEN ? "Chat Problems" : "聊天問題"}
                </h4>
              </div>
              <div className="space-y-4">
                <div className="bg-white dark:bg-gray-800 rounded-lg p-4">
                  <h5 className="text-yellow-700 dark:text-yellow-300 text-sm font-semibold mb-3">
                    {isEN
                      ? "Problem: Messages not sending"
                      : "問題：消息無法發送"}
                  </h5>
                  <div className="text-gray-700 dark:text-gray-300 text-sm space-y-2">
                    <p className="font-medium text-gray-800 dark:text-white">
                      {isEN ? "Solutions:" : "解決方案:"}
                    </p>
                    <ul className="ml-4 space-y-1">
                      <li className="flex items-center">
                        <div className="w-2 h-2 bg-yellow-500 rounded-full mr-2"></div>
                        {isEN
                          ? "Check your internet connection"
                          : "檢查網絡連接"}
                      </li>
                      <li className="flex items-center">
                        <div className="w-2 h-2 bg-yellow-500 rounded-full mr-2"></div>
                        {isEN
                          ? "Refresh the page and try again"
                          : "刷新頁面並重試"}
                      </li>
                      <li className="flex items-center">
                        <div className="w-2 h-2 bg-yellow-500 rounded-full mr-2"></div>
                        {isEN
                          ? "Ensure message is not empty or too long"
                          : "確保消息不為空或過長"}
                      </li>
                      <li className="flex items-center">
                        <div className="w-2 h-2 bg-yellow-500 rounded-full mr-2"></div>
                        {isEN
                          ? "Try logging out and back in"
                          : "嘗試註銷並重新登錄"}
                      </li>
                    </ul>
                  </div>
                </div>
                <hr className="border-gray-300 dark:border-gray-700" />
                <div className="bg-white dark:bg-gray-800 rounded-lg p-4">
                  <h5 className="text-yellow-700 dark:text-yellow-300 text-sm font-semibold mb-3">
                    {isEN ? "Problem: AI not responding" : "問題：AI無響應"}
                  </h5>
                  <div className="text-gray-700 dark:text-gray-300 text-sm space-y-2">
                    <p className="font-medium text-gray-800 dark:text-white">
                      {isEN ? "Solutions:" : "解決方案:"}
                    </p>
                    <ul className="ml-4 space-y-1">
                      <li className="flex items-center">
                        <div className="w-2 h-2 bg-yellow-500 rounded-full mr-2"></div>
                        {isEN
                          ? "Wait a few moments - AI may be processing"
                          : "等待幾分鐘 - AI可能正在處理"}
                      </li>
                      <li className="flex items-center">
                        <div className="w-2 h-2 bg-yellow-500 rounded-full mr-2"></div>
                        {isEN
                          ? "Try rephrasing your question"
                          : "嘗試重新表述您的問題"}
                      </li>
                      <li className="flex items-center">
                        <div className="w-2 h-2 bg-yellow-500 rounded-full mr-2"></div>
                        {isEN ? "Start a new conversation" : "開始新對話"}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white dark:bg-gray-800 rounded-lg p-6 border border-gray-300 dark:border-gray-700 shadow-sm">
              <div className="flex items-center mb-4">
                {/* <div className="w-6 h-6 bg-blue-500 rounded-lg flex items-center justify-center mr-3 shadow-sm">
                                    <svg
                                        className="w-4 h-4 text-white"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                                        />
                                    </svg>
                                </div> */}
                <h4 className="text-gray-800 dark:text-white text-xl font-semibold">
                  {isEN ? "Performance Issues" : "性能問題"}
                </h4>
              </div>
              <div className="space-y-4">
                <div className="bg-white dark:bg-gray-800 rounded-lg p-4 ">
                  <h5 className="text-blue-700 dark:text-blue-300 text-sm font-semibold mb-3">
                    {isEN
                      ? "Problem: Application running slowly"
                      : "問題：應用程序運行緩慢"}
                  </h5>
                  <div className="text-gray-700 dark:text-gray-300 text-sm space-y-2">
                    <p className="font-medium text-gray-800 dark:text-white">
                      {isEN ? "Solutions:" : "解決方案:"}
                    </p>
                    <ul className="ml-4 space-y-1">
                      <li className="flex items-center">
                        <div className="w-2 h-2 bg-blue-500 rounded-full mr-2"></div>
                        {isEN
                          ? "Close unused browser tabs"
                          : "關閉未使用的瀏覽器標籤"}
                      </li>
                      <li className="flex items-center">
                        <div className="w-2 h-2 bg-blue-500 rounded-full mr-2"></div>
                        {isEN ? "Clear browser cache" : "清除瀏覽器緩存"}
                      </li>
                      <li className="flex items-center">
                        <div className="w-2 h-2 bg-blue-500 rounded-full mr-2"></div>
                        {isEN
                          ? "Check available RAM and close other applications"
                          : "檢查可用RAM並關閉其他應用程序"}
                      </li>
                      <li className="flex items-center">
                        <div className="w-2 h-2 bg-blue-500 rounded-full mr-2"></div>
                        {isEN
                          ? "Try using a different browser"
                          : "嘗試使用不同的瀏覽器"}
                      </li>
                      <li className="flex items-center">
                        <div className="w-2 h-2 bg-blue-500 rounded-full mr-2"></div>
                        {isEN
                          ? "Update your browser to the latest version"
                          : "將瀏覽器更新到最新版本"}
                      </li>
                    </ul>
                  </div>
                </div>
                <hr className="border-gray-300 dark:border-gray-700" />
                <div className="bg-white dark:bg-gray-800 rounded-lg p-4">
                  <h5 className="text-blue-700 dark:text-blue-300 text-sm font-semibold mb-3">
                    {isEN
                      ? "Problem: Page not loading or displaying incorrectly"
                      : "問題：頁面無法加載或顯示不正確"}
                  </h5>
                  <div className="text-gray-700 dark:text-gray-300 text-sm space-y-2">
                    <p className="font-medium text-gray-800 dark:text-white">
                      {isEN ? "Solutions:" : "解決方案:"}
                    </p>
                    <ul className="ml-4 space-y-1">
                      <li className="flex items-center">
                        <div className="w-2 h-2 bg-blue-500 rounded-full mr-2"></div>
                        {isEN
                          ? "Hard refresh the page (Ctrl+F5 or Cmd+Shift+R)"
                          : "強制刷新頁面（Ctrl+F5或Cmd+Shift+R）"}
                      </li>
                      <li className="flex items-center">
                        <div className="w-2 h-2 bg-blue-500 rounded-full mr-2"></div>
                        {isEN
                          ? "Disable browser extensions temporarily"
                          : "暫時禁用瀏覽器擴展"}
                      </li>
                      <li className="flex items-center">
                        <div className="w-2 h-2 bg-blue-500 rounded-full mr-2"></div>
                        {isEN
                          ? "Try accessing from a different device/network"
                          : "嘗試從不同設備/網絡訪問"}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white dark:bg-gray-800 rounded-lg p-6 border border-gray-300 dark:border-gray-700 shadow-sm">
              <div className="flex items-center mb-4">
                {/* <div className="w-6 h-6 bg-gray-600 rounded-lg flex items-center justify-center mr-3 shadow-sm">
                                    <svg
                                        className="w-4 h-4 text-white"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9v-9m0-9v9"
                                        />
                                    </svg>
                                </div> */}
                <h4 className="text-gray-800 dark:text-white text-xl font-semibold">
                  {isEN ? "Browser Compatibility" : "瀏覽器兼容性"}
                </h4>
              </div>
              <div className="grid md:grid-cols-2 gap-6">
                <div className="space-y-3">
                  <h5 className="text-green-600 dark:text-green-400 text-sm font-semibold flex items-center">
                    {isEN ? "Supported Browsers:" : "支持的瀏覽器:"}
                  </h5>
                  <ul className="text-gray-700 dark:text-gray-300 text-sm space-y-2">
                    <li className="flex items-center">
                      <div className="w-2 h-2 bg-green-500 rounded-full mr-2"></div>
                      ✅ Chrome 90+ {isEN ? "(Recommended)" : "(推薦)"}
                    </li>
                    <li className="flex items-center">
                      <div className="w-2 h-2 bg-green-500 rounded-full mr-2"></div>
                      ✅ Firefox 88+
                    </li>
                    <li className="flex items-center">
                      <div className="w-2 h-2 bg-green-500 rounded-full mr-2"></div>
                      ✅ Safari 14+
                    </li>
                    <li className="flex items-center">
                      <div className="w-2 h-2 bg-green-500 rounded-full mr-2"></div>
                      ✅ Edge 90+
                    </li>
                  </ul>
                </div>
                <div className="space-y-3">
                  <h5 className="text-red-600 dark:text-red-400 text-sm font-semibold flex items-center">
                    {isEN ? "Known Issues:" : "已知問題:"}
                  </h5>
                  <ul className="text-gray-700 dark:text-gray-300 text-sm space-y-2">
                    <li className="flex items-center">
                      <div className="w-2 h-2 bg-red-500 rounded-full mr-2"></div>
                      ⚠️ Internet Explorer{" "}
                      {isEN ? "(Not supported)" : "(不支持)"}
                    </li>
                    <li className="flex items-center">
                      <div className="w-2 h-2 bg-red-500 rounded-full mr-2"></div>
                      ⚠️ Chrome {"<90"}{" "}
                      {isEN ? "(Limited features)" : "(功能受限)"}
                    </li>
                    <li className="flex items-center">
                      <div className="w-2 h-2 bg-red-500 rounded-full mr-2"></div>
                      ⚠️ Safari {"<14"}{" "}
                      {isEN ? "(Display issues)" : "(顯示問題)"}
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="bg-white dark:bg-gray-800 rounded-lg p-6 border border-gray-300 dark:border-gray-700 shadow-sm">
              <div className="flex items-center mb-4">
                {/* <div className="w-6 h-6 bg-green-500 rounded-lg flex items-center justify-center mr-3 shadow-sm">
                                    <svg
                                        className="w-4 h-4 text-white"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                        />
                                    </svg>
                                </div> */}
                <h4 className="text-gray-800 dark:text-white text-xl font-semibold">
                  {isEN ? "Getting Help" : "獲取幫助"}
                </h4>
              </div>
              <div className="space-y-4">
                <div className="bg-white dark:bg-gray-800 rounded-lg p-4 ">
                  <h5 className="text-orange-600 dark:text-orange-400 text-sm font-semibold mb-3 flex items-center">
                    {isEN ? "Before Contacting Support:" : "聯繫支持之前:"}
                  </h5>
                  <ul className="text-gray-700 dark:text-gray-300 text-sm space-y-2">
                    <li className="flex items-center">
                      <div className="w-2 h-2 bg-orange-500 rounded-full mr-2"></div>
                      {isEN
                        ? "Note the exact error message (screenshot if possible)"
                        : "記錄確切的錯誤消息（如可能請截圖）"}
                    </li>
                    <li className="flex items-center">
                      <div className="w-2 h-2 bg-orange-500 rounded-full mr-2"></div>
                      {isEN
                        ? "Record the steps that led to the problem"
                        : "記錄導致問題的步驟"}
                    </li>
                    <li className="flex items-center">
                      <div className="w-2 h-2 bg-orange-500 rounded-full mr-2"></div>
                      {isEN
                        ? "Check your browser version and operating system"
                        : "檢查瀏覽器版本和操作系統"}
                    </li>
                    <li className="flex items-center">
                      <div className="w-2 h-2 bg-orange-500 rounded-full mr-2"></div>
                      {isEN
                        ? "Try the solutions listed above first"
                        : "首先嘗試上述列出的解決方案"}
                    </li>
                  </ul>
                </div>
                <hr className="border-gray-300 dark:border-gray-700" />
                <div className="bg-white dark:bg-gray-800 rounded-lg p-4">
                  <h5 className="text-blue-600 dark:text-blue-400 text-sm font-semibold mb-3 flex items-center">
                    {isEN ? "Contact Information:" : "聯繫信息:"}
                  </h5>
                  <div className="text-gray-700 dark:text-gray-300 text-sm space-y-3">
                    <div className="flex items-center">
                      <div className="w-2 h-2 bg-blue-500 rounded-full mr-2"></div>
                      <span>
                        {isEN
                          ? "Dedicated feedback portal: "
                          : "專用反饋門戶: "}
                        <button
                          onClick={() =>
                            navigate({
                              pathname: "/feedback",
                              search: `?lang=${isEN ? "en" : "zh"}`,
                            })
                          }
                          className="text-blue-600 dark:text-blue-400 underline hover:text-blue-700 dark:hover:text-blue-300 font-medium"
                        >
                          feedback page
                        </button>
                      </span>
                    </div>
                    <div className="flex items-center">
                      <div className="w-2 h-2 bg-blue-500 rounded-full mr-2"></div>
                      <span>
                        📧 {isEN ? "Email: " : "郵箱: "}
                        <a
                          href="mailto:eugeniusedu@oomii.com"
                          className="text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300"
                        >
                          eugeniusedu@oomii.com
                        </a>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
